// Height to weight mapping table
const HEIGHT_WEIGHT_TABLE = [
  { height: 152, male: 48.0, female: 45.4 },
  { height: 155, male: 51.2, female: 48.1 },
  { height: 157, male: 53.4, female: 49.9 },
  { height: 160, male: 56.6, female: 52.6 },
  { height: 163, male: 59.9, female: 55.3 },
  { height: 165, male: 62.1, female: 57.1 },
  { height: 168, male: 65.3, female: 59.8 },
  { height: 170, male: 67.5, female: 61.6 },
  { height: 173, male: 70.7, female: 64.3 },
  { height: 175, male: 72.9, female: 66.1 },
  { height: 178, male: 76.1, female: 68.8 },
  { height: 180, male: 78.3, female: 70.6 },
  { height: 183, male: 81.5, female: 73.3 }
];

// Ideal health values by gender
export const IDEAL_HEALTH_VALUES = {
  MALE: {
    visceralFat: '1-8',
    tsf: '8-15',
    totalFatPercentage: '15%',
    bmi: '<23',
    metaAge: 'As Per Actual Age',
    skeletalMusclePercentage: '35%'
  },
  FEMALE: {
    visceralFat: '1-4',
    tsf: '8-20',
    totalFatPercentage: '20%',
    bmi: '<23',
    metaAge: 'As Per Actual Age',
    skeletalMusclePercentage: '27%'
  }
};

/**
 * Calculate ideal weight based on height and gender
 * @param {number} heightCm - Height in centimeters
 * @param {string} gender - Gender (MALE, FEMALE, OTHER)
 * @returns {number|null} - Ideal weight in kg or null if invalid input
 */
export const calculateIdealWeight = (heightCm, gender) => {
  if (!heightCm || !gender || (gender !== 'MALE' && gender !== 'FEMALE')) {
    return null;
  }

  const height = parseFloat(heightCm);
  if (isNaN(height) || height < 100 || height > 250) {
    return null;
  }

  // Find closest height in the table
  let closestEntry = HEIGHT_WEIGHT_TABLE[0];
  let minDifference = Math.abs(height - closestEntry.height);

  for (const entry of HEIGHT_WEIGHT_TABLE) {
    const difference = Math.abs(height - entry.height);
    if (difference < minDifference) {
      minDifference = difference;
      closestEntry = entry;
    }
  }

  // Return ideal weight based on gender
  return gender === 'MALE' ? closestEntry.male : closestEntry.female;
};

/**
 * Get ideal health values for display based on gender
 * @param {string} gender - Gender (MALE, FEMALE, OTHER)
 * @param {number} idealWeight - Ideal weight for this user
 * @returns {object} - Object with ideal values for each health metric
 */
export const getIdealHealthValues = (gender, idealWeight) => {
  const genderKey = (gender === 'MALE' || gender === 'FEMALE') ? gender : 'MALE';
  const idealValues = { ...IDEAL_HEALTH_VALUES[genderKey] };
  
  // Add ideal weight if provided
  if (idealWeight) {
    idealValues.weight = `${idealWeight} kg`;
  }
  
  return idealValues;
};
